import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ErrorHandlerService } from 'src/app/services/shared/error-handler/error-handler.service';

@Component({
  selector: 'app-error-handler',
  templateUrl: './error-handler.component.html',
  styleUrls: ['./error-handler.component.scss']
})
export class ErrorHandlerComponent implements OnInit {

  private _sub: any;

  constructor(private errService: ErrorHandlerService, private _toastr: ToastrService, private _authService: AuthenticationService) { }

  ngOnInit() {
    this._sub = this.errService.err.subscribe(res => {
      if(res && res['status'] != 401 && res['error']){
        this._toastr.error(res['error']);
      }
      if(res && res['status'] === 401){
        this._authService.logout();
      }
    });
  }

  ngOnDestroy(){
    this._sub.unsubscribe();
  }

}
